module.exports = {
  qqgdscpjypt:
    "Global high-end aquatic products trading platform (Shenzhen International Tuna Trading Co., LTD.)",
};



// WEBPACK FOOTER //
// ./src/lang/en.js